import { Navigate } from "react-router-dom";
import Header from "./Components/Header";

export function ProtectedRoutes({ children }) {
  const userAccess = window.localStorage.getItem("user-Access");
  const isSkipLoginImage = window.localStorage.getItem("isSkipLoginImage");
  return (
    <>
      {userAccess &&
        (isSkipLoginImage == 1 ? (
          <Navigate to="/Dashboard" replace={true} />
        ) : (
          <Navigate to="/ImageDetail" replace={true} />
        ))}
      {children}
    </>
  );
}

export function HomeRoutes({ children }) {
  const userAccess = window.localStorage.getItem("user-Access");
  return (
    <>
      {!userAccess && <Navigate to="/login" replace={true} />}
      <Header />
      {children}
    </>
  );
}
